import React, { useState } from "react";
import "../styles/CardService.css";
import "../styles/TextStyle.css";

const CardService = ({ imgSrc, hoverImg, text, onClick, onMouseEnter, onFocus }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="card-service d-flex flex-column justify-content-center align-items-center mx-1"
      style={{ cursor: "pointer", height: "100%", borderRadius: "20px" }}
      onClick={onClick}
      onMouseEnter={e => {
        setIsHovered(true);
        if (onMouseEnter) onMouseEnter(e);
      }}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={e => onFocus && onFocus(e)}
      tabIndex={0} // per abilitare focus via tastiera
    >
      <div className="d-flex flex-column align-items-center flex-grow-1 mt-2">
        <img
          src={isHovered ? hoverImg : imgSrc}
          style={{ width: '45px', height: '45px' }}
          className="img-fluid"
          alt="Card Image"
        />

        <p
          className="mt-3 text-center card-service-text text-18 text-md-24"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
};

export default CardService;
